<template>
  <!-- eslint-disable vue/no-v-html -->
  <div
    class="icon"
    v-html="svg"
  />
  <!-- eslint-enable vue/no-v-html -->
</template>

<script>
  export default {
    props: {
      svg: {
        type: String,
        required: true,
      },
    },
  }
</script>
